export default () => ({
  backdropFilter: 'blur(12px) saturate(190%) contrast(50%) brightness(130%)',
  border: '0.5px solid rgb(216, 216, 216)',
  background: 'rgba(255, 255, 255, 0.5)',
  boxShadow: 'rgba(0, 0, 0, 0.09) 0px 3px 12px',
  borderRadius: 8
});
